@if (courses && courses.length>0) {
    <div class="w-100 bg-light-subtle p-0 m-0">
      <section class="section-space mofi-demo-section layout overflow-hidden">
        <div class="container-fluid fluid-space">
          <div class="row demo-imgs g-xl-5 g-sm-3">
            <div class="carousel slide" id="carouselExampleControls" data-bs-ride="carousel">
              <div class="carousel-inner">
                <div class="d-flex justify-content-center mt-4">
                  <div class="title-bold">
                    Our Best Courses
                  </div>
                </div>
                <owl-carousel-o [options]="withControlOptions">
                  @for (course of courses; track course) {
                  <ng-template carouselSlide class="carousel-item">
                    <!-- <img class="w-100" [src]="slideData.img" alt="">  -->
                    <div class="col-xl-12 col-md-12 demo-content fadeInUp pointer" [routerLink]="['/product',course._id]">
                      <div class="mofi-demo-img h-75 w-100">
                        <div class="overflow-hidden h-100">
                          <img class="img-fluid h-100" [src]="course.mainImage" alt="default" />
                        </div>
                      </div>
                      <div class="title-wrapper">
                        <h3 class="theme-name mb-0">
                          {{course.name}}
                        </h3>
                      </div>
                    </div>
                  </ng-template>
                  }
                </owl-carousel-o>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  }